import * as WorksheetsReducer from './worksheetsReducer.model';

let defaultSearchResults = null;

export default function searchResultsReducer(
  state = defaultSearchResults,
  action
) {
  let { type, data } = action;

  switch (type) {
    case 'UPDATE_SEARCH_RESULTS':
      return Object.assign({}, state, data);

    // Reset the search results if these actions happen
    case 'SELECT_FILE':
    case WorksheetsReducer.UPDATE_SELECTED_WORKSHEET:
    case WorksheetsReducer.UPDATE_COLUMN_MAPPINGS:
      return defaultSearchResults;

    default:
      return state;
  }
}
